// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3AGAs","icon":"icon-UqsLt","text":"text-3k1wf"};